import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Empty weight'),"suffix":_vm.value.weight_unit,"outlined":"","hide-details":"auto","type":"number"},model:{value:(_vm.emptyWeight),callback:function ($$v) {_vm.emptyWeight=$$v},expression:"emptyWeight"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }